import {
  Property,
  SpaceType,
  InvestementStatus,
  State,
  Category,
  RentalType,
  InvestmentStrategyType,
  FileType,
  FundingTimelineEventType,
} from 'app/core/pages/properties/properties.model';

export const dummyDataProperty: Property = {
  visible: true,
  $id: '405',
  $collectionId: '',
  $createdAt: '',
  $databaseId: '',
  $permissions: [],
  $updatedAt: '',

  name: 'Studio in The Neighborhood, Al Barari (C214)',
  price: 8110000,
  images: [
    {
      id: '5696',
      caption: '1',
      url: 'https://s3.eu-west-1.amazonaws.com/stake-dev-env/properties/405/images/5696/1920px_main_RCui5XH1y2OjvGXRiizF8KauR2FDm2EtCCj0uXap.jpeg',
      thumbnail:
        'https://s3.eu-west-1.amazonaws.com/stake-dev-env/properties/405/images/5696/200px_thumbnail_Yw9KftNMyp6DwnCjRr3NTVgBn9xu5uRETGLhB0fT.jpeg',
      resolutions: {
        main: 'properties/405/images/5696/1920px_main_RCui5XH1y2OjvGXRiizF8KauR2FDm2EtCCj0uXap.jpeg',
        original:
          'properties/405/images/5696/original_HGSF99HIoyMoeJgICzvCYnfnn0D1I2YMOoiY6Rmt.jpeg',
        thumbnail:
          'properties/405/images/5696/200px_thumbnail_Yw9KftNMyp6DwnCjRr3NTVgBn9xu5uRETGLhB0fT.jpeg',
      },
    },
    {
      id: '5695',
      caption: '2',
      url: 'https://s3.eu-west-1.amazonaws.com/stake-dev-env/properties/405/images/5695/1200px_main_PFkMcLGIKYZkIRUUIcoH6fe2lPCpfORYG05vVhK0.jpeg',
      thumbnail:
        'https://s3.eu-west-1.amazonaws.com/stake-dev-env/properties/405/images/5695/200px_thumbnail_Eswjcu8e6NgchNOjfO4160xczWrVV8RHtq4WL8j5.jpeg',
      resolutions: {
        main: 'properties/405/images/5695/1200px_main_PFkMcLGIKYZkIRUUIcoH6fe2lPCpfORYG05vVhK0.jpeg',
        original:
          'properties/405/images/5695/original_ZLi7kj1QbhjxhJMxVZF3LNS9nJVaEDTB97WTiGjK.jpg',
        thumbnail:
          'properties/405/images/5695/200px_thumbnail_Eswjcu8e6NgchNOjfO4160xczWrVV8RHtq4WL8j5.jpeg',
      },
    },
    {
      id: '5697',
      caption: '3',
      url: 'https://s3.eu-west-1.amazonaws.com/stake-dev-env/properties/405/images/5697/2130px_main_abXzIjPdPS97Z5KQ9uJ13uW5Rv5JLD29GtralKBU.jpeg',
      thumbnail:
        'https://s3.eu-west-1.amazonaws.com/stake-dev-env/properties/405/images/5697/200px_thumbnail_FMRsPMhXCtTsW4A94dzhyuH3Sx9Uzu6ITskA6IvI.jpeg',
      resolutions: {
        main: 'properties/405/images/5697/2130px_main_abXzIjPdPS97Z5KQ9uJ13uW5Rv5JLD29GtralKBU.jpeg',
        original:
          'properties/405/images/5697/original_pleowqMTlSSlS4iglbc5AAAl4siTHXAffCwoxkHZ.jpg',
        thumbnail:
          'properties/405/images/5697/200px_thumbnail_FMRsPMhXCtTsW4A94dzhyuH3Sx9Uzu6ITskA6IvI.jpeg',
      },
    },
    {
      id: '5699',
      caption: '4',
      url: 'https://s3.eu-west-1.amazonaws.com/stake-dev-env/properties/405/images/5699/2400px_main_QQVGKEFe2AQ4QOxTrzeWNDLCGgB2d2k5HKrRHjN0.jpeg',
      thumbnail:
        'https://s3.eu-west-1.amazonaws.com/stake-dev-env/properties/405/images/5699/200px_thumbnail_wOVj1k7SBoC8zMNNU28El9bmpwuThjuOQ1pNmTGg.jpeg',
      resolutions: {
        main: 'properties/405/images/5699/2400px_main_QQVGKEFe2AQ4QOxTrzeWNDLCGgB2d2k5HKrRHjN0.jpeg',
        original:
          'properties/405/images/5699/original_pOvypxR5gjO8DzX0GBAeXsQHjVgKrtu4y119gOyS.jpg',
        thumbnail:
          'properties/405/images/5699/200px_thumbnail_wOVj1k7SBoC8zMNNU28El9bmpwuThjuOQ1pNmTGg.jpeg',
      },
    },
    {
      id: '5700',
      caption: '5',
      url: 'https://s3.eu-west-1.amazonaws.com/stake-dev-env/properties/405/images/5700/2400px_main_A8iSKaPh6H4phMUMfSk3QiyEkWkloQsVTPHTdbW3.jpeg',
      thumbnail:
        'https://s3.eu-west-1.amazonaws.com/stake-dev-env/properties/405/images/5700/200px_thumbnail_ndCAZmQONjo4pURVvALDEZOv93qErJpWJ71YbjiF.jpeg',
      resolutions: {
        main: 'properties/405/images/5700/2400px_main_A8iSKaPh6H4phMUMfSk3QiyEkWkloQsVTPHTdbW3.jpeg',
        original:
          'properties/405/images/5700/original_ZrtI3GO10ZoyKzAAF711GTVhLFoDsGzUJM95pNc9.jpg',
        thumbnail:
          'properties/405/images/5700/200px_thumbnail_ndCAZmQONjo4pURVvALDEZOv93qErJpWJ71YbjiF.jpeg',
      },
    },
    {
      id: '5701',
      caption: '6',
      url: 'https://s3.eu-west-1.amazonaws.com/stake-dev-env/properties/405/images/5701/2400px_main_d1RqXkskD24glpAA3nkjlVFxt8kzOVfO5Su9oYdr.jpeg',
      thumbnail:
        'https://s3.eu-west-1.amazonaws.com/stake-dev-env/properties/405/images/5701/200px_thumbnail_YdLHw2HJlKqQwDxFwi2AOFT5gGVyLOADMPTRkJXn.jpeg',
      resolutions: {
        main: 'properties/405/images/5701/2400px_main_d1RqXkskD24glpAA3nkjlVFxt8kzOVfO5Su9oYdr.jpeg',
        original:
          'properties/405/images/5701/original_YvC31tlV1XZSXLlnVgmzEa61XkejSwCEeFtOJm3S.jpg',
        thumbnail:
          'properties/405/images/5701/200px_thumbnail_YdLHw2HJlKqQwDxFwi2AOFT5gGVyLOADMPTRkJXn.jpeg',
      },
    },
    {
      id: '5698',
      caption: '7',
      url: 'https://s3.eu-west-1.amazonaws.com/stake-dev-env/properties/405/images/5698/2400px_main_49IaVWPoxfX7oc6LCjHVVdl5nFQZzTvEWK0mjl8t.jpeg',
      thumbnail:
        'https://s3.eu-west-1.amazonaws.com/stake-dev-env/properties/405/images/5698/200px_thumbnail_WrGZnj7xxh2mc1J7ZpHGUkHAFDj6KP3nOyaOgxPQ.jpeg',
      resolutions: {
        main: 'properties/405/images/5698/2400px_main_49IaVWPoxfX7oc6LCjHVVdl5nFQZzTvEWK0mjl8t.jpeg',
        original:
          'properties/405/images/5698/original_2du8Qh672ZAFCUo63sam2omH3gTCbRYoXZtfPOub.jpg',
        thumbnail:
          'properties/405/images/5698/200px_thumbnail_WrGZnj7xxh2mc1J7ZpHGUkHAFDj6KP3nOyaOgxPQ.jpeg',
      },
    },
    {
      id: '5702',
      caption: '8',
      url: 'https://s3.eu-west-1.amazonaws.com/stake-dev-env/properties/405/images/5702/2400px_main_YhsP64nd6RJS28I8FRgehNSVdznpDF88oUgBJJvg.jpeg',
      thumbnail:
        'https://s3.eu-west-1.amazonaws.com/stake-dev-env/properties/405/images/5702/200px_thumbnail_uDj4tz19dipqTVo6uQ6tGvYwufcXYtKL6mWz2Ral.jpeg',
      resolutions: {
        main: 'properties/405/images/5702/2400px_main_YhsP64nd6RJS28I8FRgehNSVdznpDF88oUgBJJvg.jpeg',
        original:
          'properties/405/images/5702/original_rjhq9411Kn3uWZxQ2zDfAuJSYWxS2VDBePdhY9DJ.jpg',
        thumbnail:
          'properties/405/images/5702/200px_thumbnail_uDj4tz19dipqTVo6uQ6tGvYwufcXYtKL6mWz2Ral.jpeg',
      },
    },
    {
      id: '5703',
      caption: '9',
      url: 'https://s3.eu-west-1.amazonaws.com/stake-dev-env/properties/405/images/5703/2400px_main_AbD7RdPM5SXFOTTtpSj1Nzq4vAknndjYaaeOwtRf.jpeg',
      thumbnail:
        'https://s3.eu-west-1.amazonaws.com/stake-dev-env/properties/405/images/5703/200px_thumbnail_qiTuUTkwCibn8KvWLQRkeVjqElxGAIE25KwbsbmX.jpeg',
      resolutions: {
        main: 'properties/405/images/5703/2400px_main_AbD7RdPM5SXFOTTtpSj1Nzq4vAknndjYaaeOwtRf.jpeg',
        original:
          'properties/405/images/5703/original_nUERvD1Wmc8sIkN6TLzf9Cfih843dSsOquTyK6EV.jpg',
        thumbnail:
          'properties/405/images/5703/200px_thumbnail_qiTuUTkwCibn8KvWLQRkeVjqElxGAIE25KwbsbmX.jpeg',
      },
    },
  ],
  videoTour: 'https://www.youtube.com/embed/T3dWBalOLo8',
  virtualTour: 'https://my.matterport.com/show?play=1&lang=en-US&m=gwbt1NEMb2M',
  city: 'Dubai',
  country: {
    icon: 'uae',
    name: 'United Arab Emirates',
    shortName: 'UAE',
  },
  addressCommunity: 'Al Barari',
  spaces: [
    {
      type: SpaceType.STUDIO,
      count: 1,
    },
    {
      type: SpaceType.BATH,
      count: 1,
    },
  ],
  investementStatus: InvestementStatus.AVAILABLE,
  state: State.OPERATIONAL,
  netYieldPercentage: 4.46,
  totalReturnPercentage: 40.67,
  totalInvested: 380650,
  totalInvestedPercentage: 27.19,
  propertyNumber: 613 - 5,
  category: Category.RESIDENTIAL,
  numberOfBedrooms: 1,
  investmentStrategy: {
    type: InvestmentStrategyType.HIGH_YIELD,
    name: 'Balanced',
    description:
      'A safe strategy blending consistent income, strong appreciation, and capital protection.',
    highlights: [
      {
        title: 'Proximity to Downtown Dubai',
        description:
          'Enhanced property value and appeal, providing a unique selling point and potential for tourism related benefits.',
      },
      {
        title: 'Booming neighborhood',
        description:
          'Benefit from a growing community with major infrastructure and development works under way.',
      },
    ],
  },
  appreciation: 1234,

  // Extra fields
  area: 1370,
  rentalType: RentalType.LONG_TERM_RENTAL,
  grossYieldPercentage: 7.08,
  annualRent: 129135,
  numberOfInvestors: 2967,
  totalViews: 9152,
  description:
    'Stake is offering an opportunity to invest in a 2-bedroom apartment in Belgravia, Jumeirah Village Circle, Dubai.\n\nBelgravia is a modern residential development located in Jumeirah Village Circle, Dubai. This mid-rise tower features modern studio, 1-, and 2-bedroom apartments, designed with meticulous attention to detail and high-quality finishes. Handed over by Ellington Properties in 2017, the project offers premium amenities, including a swimming pool, fitness center, landscaped gardens, and a children\u2019s play area. Situated in the heart of JVC, Belgravia 3 blends comfort with urban living and provides residents with easy access to key areas of Dubai.',
  documents: [
    {
      name: 'Investor Memo - MAG 910 - 808 (EN)',
      type: FileType.PDF,
      url: 'https://drive.google.com/file/d/1joZsUj2F8EFvtM-g67wMs3mjk7a6-d4b/view?usp=sharing',
    },
    {
      name: 'Projections - Mag 910 808 (Listing)',
      type: FileType.XLSX,
      url: 'https://docs.google.com/spreadsheets/d/1ArLGqr-QfkR0Waki46BnOz_a6r94g5iZ/edit?usp=sharing&ouid=100401382296189541003&rtpof=true&sd=true',
    },
    {
      name: 'Investor Memo - MAG 910 - 808 (AR)',
      type: FileType.PDF,
      url: 'https://drive.google.com/file/d/1ROdGYPbtgnt5F5nVGhuqQv5Uz89Vf6JO/view?usp=sharing',
    },
    {
      name: 'Initial Valuation Report - MAG 910 808 - February 2025',
      type: FileType.PDF,
      url: 'https://drive.google.com/file/d/1-VPdi4jaH8dM9fJaGsu88qgXu8A36tiv/view?usp=sharing',
    },
  ],
  location: {
    lat: 25.088537136896196,
    lng: 55.14685433461653,
  },
  neighbourhood: {
    name: 'MBR City',
    url: '',
    description:
      "Mohammed Bin Rashid City is Dubai\u2019s luxury urban oasis, and is one of the largest mixed-use developments in the UAE. This city within a city offers high-end residential communities, vibrant commercial hubs, and the world's largest man-made lagoon, as well as various eateries, entertainment centres and retail shops. With many more futuristic developments coming up, MBR City has proven to be a community with a bustling environment in an ultra-modern setting.",
  },
  fundingTimeline: [
    {
      type: FundingTimelineEventType.FUNDING_DATE,
      expectedAt: new Date('2025-03-24'),
    },
    {
      type: FundingTimelineEventType.DOCUMENT_DISTRIBUTION,
      expectedAt: new Date('2025-04-08'),
    },
    {
      type: FundingTimelineEventType.FIRST_RENTAL_PAYMENT,
      expectedAt: new Date('2025-05-31'),
      projectedAt: new Date('2025-04-30'),
    },
  ],

  // For renovation
  // fundingTimeline: [
  //   {
  //     type: FundingTimelineEventType.FUNDING_DATE,
  //     expectedAt: new Date('2025-02-24'),
  //     completedAt: new Date('2025-02-01'),
  //   },
  //   {
  //     type: FundingTimelineEventType.DOCUMENT_DISTRIBUTION,
  //     expectedAt: new Date('2025-04-08'),
  //   },
  //   {
  //     type: FundingTimelineEventType.RENOVATION,
  //     expectedAt: new Date('2025-06-1'),
  //   },
  //   {
  //     type: FundingTimelineEventType.REVALUATION_AND_LISTED,
  //     expectedAt: new Date('2025-07-30'),
  //   },
  //   {
  //     type: FundingTimelineEventType.EXPECTED_SALE,
  //     expectedAt: new Date('2025-09-30'),
  //     projectedAt: new Date('2025-10-30'),
  //   },
  // ],

  transactionCost: 818034,
  // investmentCost: 11616637, // This is for renovation calculations
  investmentCost: 8928034,
  annualServiceCharges: 16590,
  annualManagementMaintenance: 16225,
  netIncome: 96320,
  renovationScope: {
    renovationBudget: 2616250,
    operationalBudget: 72353,
    projectedAppreciation: 1383363,
    projectedUnutilisedFunds: 296704,
    projectedExitCostsWithVat: 547449,
    projectedExitPrice: 12749255,
    description:
      'This Victory Heights villa offers exceptional potential. It will gain a fifth bedroom, enlarged living area, and extended courtyard to rival spacious C1 models.A complete interior upgrade will enhance all MEP systems with premium sanitary fittings, while a contemporary kitchen with top-tier appliances and luxurious finishes is introduced.<bt>All bedrooms will be redesigned with modern layouts, high-end finishes, and en-suite bathrooms.The renovation promises an unparalleled luxury residence featuring a unique outdoor area and swimming pool, ensuring timeless elegance.',
    renovationDurationMinMonths: 6,
    renovationDurationMaxMonths: 8,
  },

  // FUNDED
  fundedDate: new Date('2025-03-15'),
  latestValuation: 700000,

  // EXITED
  grossTotalRentalIncome: 143000,
  grossSellPrice: 3200000,
  exitDate: new Date('2024-09-30'),
};

// "investment_strategy": {
//   "slug": "capital-growth",
//   "name": "Capital Growth",
//   "description": "High appreciation potential due to market trends, upcoming infrastructure, or prime locations."
// }

// "property_investment_strategy_highlights": [
//   {
//       "id": 2565,
//       "name": "Premium neighborhood",
//       "title": "Proximity to Downtown Dubai",
//       "description": "Enhanced property value and appeal, providing a unique selling point and potential for tourism related benefits."
//   },
//   {
//       "id": 2566,
//       "name": "Limited supply",
//       "title": "Booming neighborhood",
//       "description": "Benefit from a growing community with major infrastructure and development works under way."
//   }
// ],

// ------------------------------------------------------------------------------------------------

// "investment_strategy": {
//   "slug": "balanced",
//   "name": "Balanced",
//   "description": "A safe strategy blending consistent income, strong appreciation, and capital protection."
// },

// [
//   {
//     "id": 2505,
//     "name": "Reputable developer",
//     "title": "Reputable developer",
//     "description": "Built by one of Dubai’s leading real estate developers, Emaar Properties, with a stellar reputation."
//   },
//   {
//     "id": 2506,
//     "name": "High-end amenities",
//     "title": "High-end amenities",
//     "description": "Luxurious amenities enhance lifestyle and justify premium rents, attracting high-end tenants."
//   }
// ],

// ------------------------------------------------------------------------------------------------

// "investment_strategy": {
//   "slug": "fix-n-flip",
//   "name": "Fix n' Flip",
//   "description": "Purchase a market-undervalued property, renovate it, and quickly resell at a higher value."
// },

// "property_investment_strategy_highlights": [
//   {
//       "id": 2673,
//       "name": "Proximity to iconic landmark [xxx]",
//       "title": "Prestigious Community",
//       "description": "Situated in a sought-after golf community, centered around The Els Club, Victory Heights offers luxury living with resale potential."
//   },
//   {
//       "id": 2674,
//       "name": "Proximity to commercial hub [xxx]",
//       "title": "High-Value Transformation",
//       "description": "Expanding living space and adding a new bedroom boosts the property value, meeting demand for larger homes in established communities."
//   }
// ],

// ------------------------------------------------------------------------------------------------

// "investment_strategy": {
//   "slug": "high-yield",
//   "name": "High Yield",
//   "description": "Properties that offer higher than average rental yields, designed to maximise rental income."
// },

// "property_investment_strategy_highlights": [
//   {
//       "id": 2691,
//       "name": "High-end amenities",
//       "title": "High-end amenities",
//       "description": "Luxurious amenities enhance lifestyle and justify premium rents, attracting high-end tenants."
//   },
//   {
//       "id": 2692,
//       "name": "Reputable developer",
//       "title": "Reputable developer",
//       "description": "Built by one of Dubai's leading real estate developers with a stellar reputation."
//   }
// ],
